import { RouteFactory } from "@app/routePaths";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { NotificationTypeEnum } from "@features/notifications/NotificationToasts/utils/types";

export const EMPTY_NOTIFICATION = {
  text: "",
  link: "",
};

export const KEYWORD_ADDED_SUCCESSFUL_NOTIFICATION = {
  text: "Keyword added to your list",
  type: NotificationTypeEnum.notificationWithLink,
  link: RouteFactory.myAccount,
  icon: IconTypeEnum.chrevonRightLightArrow,
};

export const KEYWORD_REMOVED_SUCCESSFUL_NOTIFICATION = {
  text: "Keyword removed",
  type: NotificationTypeEnum.notificationWithoutLink,
};

export const KEYWORD_UPDATED_UNSUCCESSFUL_NOTIFICATION = {
  text: "Oops! Error. Please retry.",
  type: NotificationTypeEnum.notificationWithoutLink,
};

export const KEYWORD_REACH_LIMIT_NOTIFICATION = {
  text: "You have reached the limit of your keywords",
  type: NotificationTypeEnum.notificationWithoutLink,
};
